document.addEventListener("DOMContentLoaded", function () {

  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  // サムネイルスライダー
  const thumbSwiper = new Swiper(".thumb-swiper", {
    direction: isMobile ? "horizontal" : "vertical",
    slidesPerView: isMobile ? 5 : 6,
    spaceBetween: isMobile ? 12 : 16,
    navigation: isMobile
      ? false
      : {
          nextEl: ".thumb-down",
          prevEl: ".thumb-up",
        },
    watchSlidesProgress: true,
    freeMode: true,
  });

  // メインスライダー
  const mainSwiper = new Swiper(".main-swiper", {
    direction: isMobile ? "horizontal" : "vertical",
    slidesPerView: 1,
    effect: "slide",
    thumbs: {
      swiper: thumbSwiper,
    },
  });

});
